import React from 'react';
import classnames from 'classnames';
import AggregationBubble from '@intelligence/components/AggregationBubble';
import Tag from '@intelligence/components/GenreSelect/components/Tag';

import type { IBaseProps, ITag } from '@intelligence/components/GenreSelect/types';
import type { ITagProps } from '@intelligence/components/GenreSelect/components/Tag';

import '@intelligence/components/GenreSelect/components/Tags/index.scss';

interface ITagsProps extends IBaseProps {
  data?: ITag[];
  searchInputSlot?: React.ReactElement;
  onDelete?: ITagProps['onDelete'];
}

const Tags: React.FC<ITagsProps> = (props) => {
  const { style, className, data, searchInputSlot, onDelete } = props;

  return (
    <div style={style} className={classnames('intelligence-tags-container', className)}>
      <ul className="intelligence-tags">
        {data
          ?.filter((item) => item?.value && item?.label)
          ?.map((item) => {
            const itemKey = item?.key || item?.data?.path?.join('>') || item.value;
            const itemValue = item.value;
            const itemLabel = item.label;
            return (
              <li key={itemKey} className="intelligence-tag-container">
                <AggregationBubble
                  placement="top"
                  diyClassName={classnames({ 'bubble-width-700': itemLabel && itemLabel.length > 600 })}
                  customBubbleContent={itemLabel}
                  DomOrText={<Tag label={itemLabel} value={itemValue} data={item?.data} onDelete={onDelete} />}
                />
              </li>
            );
          })}
        {React.isValidElement(searchInputSlot) && (
          <li key="search-input" className="tag search-input-container">
            {searchInputSlot}
          </li>
        )}
      </ul>
    </div>
  );
};

export default Tags;
